import { useQuery } from "react-apollo";
import ProductQuery from "./ProductQuery.gql";

const useProductBySkuLoader = (sku, Query = ProductQuery) => {
  const { loading, error, data } = useQuery(Query, {
    variables: {
      sku,
    },
  });
  return { loading, error, product: data?.product };
};

export default useProductBySkuLoader;
